import { Component, Input } from '@angular/core';
import { OverviewWallet } from '../../models/overview.model';

@Component({
  selector: 'app-wallet-summary-card',
  standalone: false,
  templateUrl: './wallet-summary-card.html',
})
export class WalletSummaryCard {
  @Input({ required: true }) wallet!: OverviewWallet;
}
